import { useEffect, useState } from "react"

import LayoutPresetBuilds from "../../containers/PresetBuilds/LayoutPresetBuilds"
import useAuth from "../../Hooks/useAuth"
import { getApiHelper, postApiHelper } from "../../util/apiHelpers"

function GlobalBuilds() {
  const authPermRolsGB = useAuth([""], false, ["super-admin", "admin"], true)
  const [data, setData] = useState([])
  const [seedMessage, setSeedMessage] = useState("")
  const [seeding, setSeeding] = useState(false)

  const getPresets = () => {
    getApiHelper(`api/Presets?presetTypeId=4`)
      .then((res) => {
        setData(res.data)
      })
      .catch((e) => console.log(e))
  }

  const handleSeedGlobalBuilds = () => {
    setSeeding(true)
    setSeedMessage("")
    postApiHelper(`api/Presets/seed-global-builds`)
      .then((res) => {
        const { created, skipped } = res.data
        setSeedMessage(
          `Seed complete: ${created} created, ${skipped} already existed.`
        )
        getPresets()
      })
      .catch((e) => {
        console.log(e)
        setSeedMessage("Failed to seed global builds.")
      })
      .finally(() => setSeeding(false))
  }

  useEffect(() => {
    getPresets()
  }, [])

  const leftPanelTopContent = authPermRolsGB[2] ? (
    <div className="mb-4 flex flex-col gap-2">
      <button
        type="button"
        onClick={handleSeedGlobalBuilds}
        disabled={seeding}
        className="w-full text-white bg-[#298FC2] rounded-lg text-sm px-4 py-2.5 font-bold disabled:opacity-50"
      >
        {seeding ? "Seeding..." : "Seed Standard Global Builds"}
      </button>
      {seedMessage ? (
        <span className="text-xs text-[#586283] text-center">
          {seedMessage}
        </span>
      ) : null}
    </div>
  ) : null

  return (
    <LayoutPresetBuilds
      nameBuilds="Global"
      data={data}
      leftPanelTopContent={leftPanelTopContent}
    />
  )
}

export default GlobalBuilds
